import { configureStore } from "@reduxjs/toolkit";
import sidebarAsanaReducer from "./Slices/SidebarAsanaSlice";

export const store = configureStore({
  reducer: {
    sideBarAsana: sidebarAsanaReducer,
  },
});
